import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
import FeeBreakdown from './FeeBreakdown'
import DineroPropShape from '../../../../../utils/propTypes/dinero'

const InvoiceAmountCell = ({getValue, row}) => (
  <Box display="flex" flexDirection="column" className="fs-mask">
    <Text mb="xxs" fontWeight="medium">
      {getValue()}
    </Text>
    <FeeBreakdown
      id={row.original.id}
      feeAmount={row.original.feeAmount?.toFormat()}
      feeRate={row.original.feeRate}
      showBreakdown={row.original.showBreakdown}
      priceWithinMaximumLimit={row.original.priceWithinMaximumLimit}
      maximumFeeRate={row.original.maximumFeeRate}
    />
  </Box>
)

InvoiceAmountCell.propTypes = {
  getValue: PropTypes.func.isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      id: PropTypes.string.isRequired,
      feeRate: PropTypes.string.isRequired,
      feeAmount: PropTypes.shape(DineroPropShape).isRequired,
      showBreakdown: PropTypes.bool.isRequired,
      priceWithinMaximumLimit: PropTypes.bool.isRequired,
      maximumFeeRate: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
}

export default InvoiceAmountCell
